/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Resume_PaymentInputs */

const vi_pos_resume_payment = /** @type {(inputs: Pos_Resume_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem thanh toán`)
};

/**

* @param {Pos_Resume_PaymentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_resume_payment = /** @type {((inputs?: Pos_Resume_PaymentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Resume_PaymentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_resume_payment(inputs)
});